<template lang="pug">
  .component-ranger-picker
    VueCtkRangeDatePicker(v-model ="myRange", :range="true" :label="label" :noLabel ="true" :noHeader="false" :color="color" :format="format" :formatted="'ll'"
      @input="dateRangeSelected" :value="value")

</template>

<script>

  import VueCtkRangeDatePicker from 'vue-ctk-date-time-picker';
  import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

  export default {
    name: 'DateRangePicker',
    components: {
      VueCtkRangeDatePicker
    },

    data() {
      return {
        myRange: this.value,

      }

    },
    props: {
      label: {type: String, default: "Select range"},
      format: {type: String, default: "YYYY-MM-DD"},
      value: {
        type: Object,
        default: () => {}
      },
      color: {type:String, default: "#5EB9CF"}
    },
    mounted() {
      if (this.value && this.value.start && this.value.end) {
        this.dateRangeSelected(this.value)
      }
    },
    methods: {
      dateRangeSelected(range) {
        if(range == null) {
          range = { start: '', end: ''}
        }
        this.$emit('input', {start: range.start, end: range.end})
      },

    },

  }
</script>

<style lang="sass">
  .header-picker
    display: block !important
  .shortcuts-container
    height: 100% !important
</style>



// WEBPACK FOOTER //
// DateRangePicker.vue?38b893b1